import React from 'react';
import { currencySelectOptions } from '../../../constants/industry';

interface CurrencySelectorProps {
  value: string;
  onChange: (currency: string) => void;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ value, onChange }) => {
  return (
    <div className="flex gap-2 bg-gray-700 p-1 rounded-lg w-fit">
      {currencySelectOptions.map(currency => {
        const isActive = value === currency.value;
        return (
          <button
            key={currency.value}
            type="button"
            onClick={() => onChange(currency.value)}
            className={`px-3 h-7 rounded-md border transition-colors ${
              isActive
                ? 'bg-black border-emerald-400 shadow-[0_0_0_2px_rgba(146,208,80,0.6)_inset] text-white'
                : 'bg-gray-700/50 border-gray-600 text-gray-400 hover:border-emerald-500'
            }`}
          >
            <span className="font-semibold tracking-wide text-xs">{currency.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CurrencySelector;
